<style lang="less" scoped>
  .query-title-div {
    width: 110px !important;
  }
  .lang-width {
    width: 450px !important;
  }
  .margin-tb {
  height: 32px;
  margin-top: 4px;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">支付订单列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="getListData(pagination, true)">
          搜 索
        </button>
        <button class="common-bg-button"
          @click="() => {
              showMultiQuerys = !showMultiQuerys;
            }"
          >高级筛选</button>
      </div>
            <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
            <div class="margin-bottom-16">
              <el-row :gutter="20">
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">购买订单编号</p>
                  <el-input clearable
                            v-model="queryInfo.walletListNo"
                            size="small"
                            placeholder="请输入购买订单编号"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">用户手机号</p>
                  <el-input clearable
                            v-model="queryInfo.mobile"
                            size="small"
                            placeholder="请输入用户手机号"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">购买名称</p>
                  <el-input clearable
                            v-model="queryInfo.packagName"
                            size="small"
                            placeholder="请输入购买名称"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">购买时间</p>
                  <div class="flex-r">
                    <el-date-picker
                      class="full-width"
                      size="small"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="paidTime"
                      @change="pickdate(paidTime)"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="margin-bottom-16" v-if="0">
              <el-row :gutter="20">
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">退款方式</p>
                  <el-select v-model="queryInfo.select" size="small" style="width: 100%" >
                    <el-option label="芝麻免押" value="01" />
                    <el-option label="手动退款" value="02" />
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">退款原因</p>
                  <el-select v-model="queryInfo.select" size="small" style="width: 100%">
                    <el-option label="平台测算" value="01" />
                    <el-option label="用户申请" value="02" />
                    <el-option label="其他" value="03" />
                  </el-select>
                </el-col>
                <el-col :span="6">
                  <p class="margin-bottom-5 font-14">退款操作时间</p>
                  <div class="flex-r">
                    <el-date-picker
                      class="full-width"
                      size="small"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="paidTime"
                      @change="pickdate(paidTime)"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
                  </div>
                </el-col>
              </el-row>
            </div>
            
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections=" (sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
      
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime:[],
      showMultiQuerys:false,
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          // {
          //   id: 'report',
          //   label: '报表',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.id)
          //     this.$store.commit('setPileNo', row.pileNo)
          //     // this.$router.push({
          //     // 	name: pageConfig.reportDetailRouter
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'repair',
          //   label: '维修',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileEntity.pileCode)
          //     // this.$router.push({
          //     // 	name: pageConfig.repairListDetail
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.repairListDetail })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },

          // {
          //   id: 'charge',
          //   label: '充电记录',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     debugger
          //     this.$store.commit('setEditId', row.pileCode)
          //     // this.$router.push({ name: pageConfig.chargeDetailRouter });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.chargeDetailRouter })
          //         .href,
          //       '_blank'
          //     )
          //   },
          // },
          // {
          //   id: 'fault',
          //   label: '故障记录编辑',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.id)
          //     // this.$router.push({ name: pageConfig.faultDetail });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.faultDetail }).href,
          //       '_blank'
          //     )
          //   }
          // },
          // {
          //   id: 'relation',
          //   label: '关联账号',
          //   type: 'primary',
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit('setEditId', row.pileCode)
          //     window.open(
          //             this.$router.resolve({ name: pageConfig.relationNum }).href,
          //             '_blank'
          //     )
          //   }
          // }
        ],
      }, // 列操作按钮
    }
  },
  methods: {
      //获取数据
    init() {
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.privatePile.pileUseWalletListWeb, _.queryInfo).then(res => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
          this.$U.error('请选择需要操作的对象');
          return false;
      }
      if (selections.length > 1) {
          this.$U.error('只能选择一个操作的对象');
          return false;
      }
      return true;
    },
    //选择时间
    pickdate(time){
        console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTransactionSucceedTime = time ? time[0]: ''
      _.queryInfo.toTransactionSucceedTime = time ? time[1]: ''
    },
    //重置
    reset() {
      delete this.queryInfo.walletListNo
      delete this.queryInfo.mobile
      delete this.queryInfo.packagName
      delete this.queryInfo.fromTransactionSucceedTime
      delete this.queryInfo.toTransactionSucceedTime
      this.paidTime = []
      this.getListData(this.pagination,true)
    },
  },
  mounted() {
    this.init()
  },
}
</script>
